import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { formatDate, formatDateRange } from '../../../../utils/dateTimeUtils';
import IconSection from '../../../_new_card_components/IconSection';

export default function DateRange(props) {
  const { project } = props;

  return (
    <IconSection
      icon={CalendarIcon}
      title={project.data.specificDate === 'Yes' ? (
        <span>
          {formatDate(project.data.date)}
        </span>
      ) : (
        <span>
          {formatDateRange(project.data.startDate, project.data.endDate)}
        </span>
      )}
      tooltip="Date range"
    />
  );
};
